const configTerms = {
    privacy: {
        termsKey: 'cs_privacy',
    },
    stipulation: {
        termsKey: 'cs_stipulation',
    },
    payment:{
        termsKey:  'cs_credit_msg'
    },
    quit:{
        termsKey:  'cs_leave'
    }
}

export default {
    methods: {
        returnTermsConfig(type) {
            return configTerms[type];
        }
    },
    data(){
        return{
        }
    }
}